import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loader2, Printer, BookText, Scale, Mic, StickyNote } from "lucide-react";

const ICONS = { "Vocabulaire pro": BookText, "Règles DGCCRF": Scale, "Méthode": Mic };

function renderContent(content) {
  return content.split("\n").map((line, i) => {
    if (line.trim() === "") return <div key={`sp-${i}`} className="h-1.5" />;
    const parts = line.split(/(\*\*.+?\*\*)/g);
    const node = parts.map((p, j) =>
      p.startsWith("**") ? <strong key={`b-${i}-${j}`} className="text-slate-900 font-bold">{p.slice(2, -2)}</strong> : p
    );
    const isList = line.match(/^\d+\./) || line.startsWith("-");
    return <p key={`ln-${i}`} className={`text-slate-600 font-medium mb-1 ${isList ? "pl-3" : ""}`}>{node}</p>;
  });
}

export default function MemosPage() {
  const [memos, setMemos] = useState(null);

  useEffect(() => {
    api.get("/memos").then(({ data }) => setMemos(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!memos) return <div className="flex justify-center py-32"><Loader2 className="h-8 w-8 text-orange-400 animate-spin" /></div>;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10 mz-rise">
      <p className="text-sm font-bold text-sky-500 uppercase tracking-wide">Fiches à imprimer</p>
      <h1 className="font-display text-3xl sm:text-4xl font-semibold text-slate-900 mt-1">Mémos</h1>
      <p className="text-slate-500 font-medium mt-1">Tes fiches repères : vocabulaire pro, règles DGCCRF, méthode de soutenance.</p>

      <div className="mt-8 space-y-5">
        {memos.map((m) => {
          const Icon = ICONS[m.category] || StickyNote;
          return (
            <div key={m.id} className="rounded-3xl bg-white border border-slate-100 shadow-sm p-7" data-testid={`memo-${m.id}`}>
              <div className="flex items-start justify-between gap-4">
                <div className="flex items-start gap-3">
                  <div className="h-11 w-11 rounded-2xl bg-sky-100 text-sky-600 flex items-center justify-center shrink-0">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div>
                    <span className="text-[11px] font-extrabold uppercase tracking-wide text-slate-400">{m.category}</span>
                    <h2 className="font-display text-xl font-semibold text-slate-900">{m.title}</h2>
                  </div>
                </div>
                {m.printable && (
                  <button
                    onClick={() => window.print()}
                    data-testid={`print-${m.id}`}
                    className="hidden sm:inline-flex items-center gap-1.5 text-slate-500 hover:text-orange-600 font-bold text-sm shrink-0"
                  >
                    <Printer className="h-4 w-4" /> Imprimer
                  </button>
                )}
              </div>
              <div className="mt-4 leading-relaxed">{renderContent(m.content)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
